import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper";
import testimonialsData from "../../data/testimonials.json";

const Testimonials = () => {
  return (
    <section className="testimonials-one pt-120 pb-120">
      <style>
        {`
          .testimonial-card__text {
            max-height: 300px !important;
            overflow-y: auto !important;
            padding-right: 15px !important;
            display: block !important;
            flex: 1 !important;
            position: relative !important;
            z-index: 10 !important;
            touch-action: pan-y !important;
            pointer-events: auto !important;
          }
          .testimonial-card__text::-webkit-scrollbar {
            width: 6px !important;
            display: block !important;
          }
          .testimonial-card__text::-webkit-scrollbar-track {
            background: #f1f1f1 !important;
            border-radius: 10px !important;
          }
          .testimonial-card__text::-webkit-scrollbar-thumb {
            background: var(--thm-base, #fd7e14) !important;
            border-radius: 10px !important;
          }
          .testimonial-card__text::-webkit-scrollbar-thumb:hover {
            background: #e67300 !important;
          }
          /* Ensure card doesn't hide our scrollbar */
          .testimonial-card {
            overflow: visible !important;
            display: flex !important;
            flex-direction: column !important;
          }
        `}
      </style>
      <div className="container">
        <div className="block-title text-center">
          <p className="block-title__tagline">our testimonials</p>
          <h2 className="block-title__title">
            What they’re talking about <br /> our company
          </h2>
        </div>
        <Swiper
          className="thm-swiper__slider swiper-container"
          modules={[Autoplay, Pagination]}
          spaceBetween={30}
          slidesPerView={3}
          autoplay={{ delay: 5000 }}
          pagination={{ clickable: true }}
          noSwiping={true}
          noSwipingClass="swiper-no-swiping"
          breakpoints={{
            0: {
              spaceBetween: 0,
              slidesPerView: 1,
            },
            768: {
              spaceBetween: 30,
              slidesPerView: 2,
            },
            992: {
              spaceBetween: 30,
              slidesPerView: 3,
            },
          }}
        >
          {testimonialsData.map((item, index) => (
            <SwiperSlide key={index}>
              <div
                className="testimonial-card"
                style={{ height: "450px", margin: "30px" }}
              >
                <div className="testimonial-card__info">
                  <div className="testimonial-card__meta">
                    <div className="testimonial-card__stars">
                      <i className="fa fa-star"></i>
                      <i className="fa fa-star"></i>
                      <i className="fa fa-star"></i>
                      <i className="fa fa-star"></i>
                      <i className="fa fa-star"></i>
                    </div>
                    <h3
                      className="testimonial-card__name"
                      style={{ marginTop: "25px" }}
                    >
                      {item.name}
                    </h3>
                    {/* {item.date && (
                      <p className="testimonial-card__designation">
                        {item.date}
                      </p>
                    )} */}
                  </div>
                </div>
                {/* <span className="testimonial-card__line"></span> */}
                <div
                  className="testimonial-card__text swiper-no-swiping"
                  style={{ marginTop: "20px" }}
                >
                  <p>{item.review}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonials;
